import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen bg-[#155e3f]" />;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
